module.exports = __webpack_public_path__ + "static/media/cnn.com_2016_04_21_entertainment_prince-estate-death_index.html_plot.52e1261c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/storySparklines/cnn.com_2016_04_21_entertainment_prince-estate-death_index.html_plot.png
// module id = 368
// module chunks = 0